import HttpService from "./htttp.service";

class ComplaintRequirementsService {
  // ComplaintRequirementsEndpoint = process.env.API_URL;

  getComplaintRequirements = async () => {
    const getComplaintRequirements = "dash/complaint_requirements";
    return await HttpService.get(getComplaintRequirements);
  };

  getSingleComplaintRequirements = async (id) => {
    const getSingleComplaintRequirements = `dash/complaint_requirements/${id}`;
    return await HttpService.get(getSingleComplaintRequirements);
  };

  createComplaintRequirements = async (payload) => {
    const createComplaintRequirements = "dash/complaint_requirements/new";
    return await HttpService.post(createComplaintRequirements, payload);
  };

  editComplaintRequirements = async (id, payload) => {
    const editComplaintRequirements = `dash/complaint_requirements/${id}`;
    return await HttpService.put(editComplaintRequirements, payload);
  };

  deleteComplaintRequirements = async (id, payload) => {
    const deleteComplaintRequirements = `dash/complaint_requirements/${id}`;
    return await HttpService.delete(deleteComplaintRequirements, payload);
  };
}

export default new ComplaintRequirementsService();
